import { render, staticRenderFns } from "./SettingsPageNew.vue?vue&type=template&id=e8328e92&scoped=true&"
import script from "./SettingsPageNew.vue?vue&type=script&lang=js&"
export * from "./SettingsPageNew.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPageNew.vue?vue&type=style&index=0&id=e8328e92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8328e92",
  null
  
)

export default component.exports